import { render, staticRenderFns } from "./ChallengesArchive.vue?vue&type=template&id=69013712&scoped=true"
import script from "./ChallengesArchive.vue?vue&type=script&lang=js"
export * from "./ChallengesArchive.vue?vue&type=script&lang=js"
import style0 from "./ChallengesArchive.vue?vue&type=style&index=0&id=69013712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69013712",
  null
  
)

export default component.exports